const css = `.L1RKSG__dayLabel{width:36px;height:36px;z-index:1;border-radius:50%;justify-content:center;align-items:center;display:flex}.L1RKSG__prominent.L1RKSG__primary{background:#007aff}.L1RKSG__prominent.L1RKSG__secondary{background:#f5447b}.L1RKSG__info:not(.L1RKSG__prominent){background:#f5ac38}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"secondary":"L1RKSG__secondary","prominent":"L1RKSG__prominent","info":"L1RKSG__info","dayLabel":"L1RKSG__dayLabel","primary":"L1RKSG__primary"};
